import CONNECT_KB from '@/graphql/Website/Integrations/Kickbite/ConnectKickbiteIntegration.gql';
import UPDATE_KB from '@/graphql/Website/Integrations/Kickbite/UpdateConnectionKickbiteIntegration.gql';
import { authClient } from '../main'

export default class KickbiteResource {
    async connect (websiteId, appId, marketId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_KB,
            variables: {
                websiteId: websiteId,
                appId: appId,
                marketId: marketId
            }
        })
    }

    async updateConnection (websiteId, appId, marketId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_KB,
            variables: {
                websiteId: websiteId,
                appId: appId,
                marketId: marketId
            }
        })
    }
}
